import { useEffect, useState } from 'react';
import { CURRENT_LOCATION_ID } from '../util/googleMaps';
import { useGeocoder } from '../services/GeocoderGoogleMaps';

const currentLocationData = {
    id: CURRENT_LOCATION_ID,
    predictionPlace: {},
};
/**
 * Resolve user location lat lng from userLocation
 * publicData field, or request it via Geo API
 */
export const useCurrentUserLocation = ({ user }) => {
    const [currentUserLocationData, setCurrentUserLocationData] = useState(null);

    const geocoder = useGeocoder();

    const { userLocation } = user.attributes.profile.publicData;

    useEffect(() => {
        if (typeof userLocation === 'object') {
            setCurrentUserLocationData({
                origin: userLocation,
            });
        } else {
            geocoder.getPlaceDetails(currentLocationData).then(response => {
                setCurrentUserLocationData(response);
            });
        }
    }, [userLocation]);

    return currentUserLocationData;
};
